import { truncate } from 'lodash';

import { stripHtmlTags } from 'src/lib/html';

import { SUGGESTED_PROJECT_NAME_LENGTH_LIMIT } from './const';

// A block boundary separates words, so each block tag becomes a space before the tags are dropped.
// Inline tags stay out of the list: they can sit inside a word.
const HTML_BLOCK_TAG_REGEX = /<\/?(p|div|br|li|ul|ol|h[1-6]|blockquote|pre|tr|td|th)\b[^>]*>/gi;

/**
 * Turns the text a view offers as a project name into one: plain text on one line, within the
 * name's length limit. Views offer editor content, which is often HTML.
 */
export const formatSuggestedProjectName = (text: string): string => {
  const plainText = stripHtmlTags(text.replace(HTML_BLOCK_TAG_REGEX, ' '));
  const name = plainText.replace(/\s+/g, ' ').trim();
  return truncate(name, { length: SUGGESTED_PROJECT_NAME_LENGTH_LIMIT });
};
